var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drop',{staticStyle:{"height":"12px","width":"100%"},on:{"dragover":_vm.dragOver,"dragleave":_vm.dragLeave,"drop":_vm.dragLeave}})
}
var staticRenderFns = []

export { render, staticRenderFns }